

export const REACT_APP_SECRET_KEY = "6Lf0KBwpAAAAAEjibd9vtjRv2aWFwNgNanV3FB-8"

export const REACT_APP_SITE_KEY = "6Lf0KBwpAAAAALsxUDtixvwpl39YYAeLJFwvgFnK"